import * as React from 'react';
import { find, propEq } from 'ramda';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';

export const addDollarSign = (
  value: string | number,
  options: {
    addMinus?: boolean;
    addPlus?: boolean;
  } = {}
) => {
  const { addMinus = true, addPlus = false } = options;

  const split = value.toString().split('-');
  if (split.length > 1) {
    return addMinus ? `-$${split[1]}` : `$${split[1]}`;
  } else {
    return addPlus ? `+$${split[0]}` : `$${split[0]}`;
  }
};

export const formatFieldValue = (
  value: any,
  type: FieldType,
  format?: FieldFormat,
  options?: any[]
) => {
  if (!value) return '-';
  switch (format) {
    case 'dollar':
    case 'percentage':
      if (isNaN(value)) value = 0;
      if (!value) return '-';
      const withDecimals = Number(value).toFixed(2);

      if (format === 'dollar') {
        return addDollarSign(numberWithCommas(withDecimals));
      } else if (format === 'percentage') {
        return `${withDecimals}%`;
      } else break;
    default: {
      if (type === 'select') {
        const selectedOption = find(propEq(value, 'value'))(options!);
        return selectedOption ? selectedOption.name : value;
      } else if (type === 'date' && value) {
        const split = value.split('-');
        return `${split[1]}/${split[2]}/${split[0]}`;
      } else {
        return value;
      }
    }
  }
};

export const getInputAdornment = (format?: FieldFormat) => {
  switch (format) {
    case 'dollar': {
      return {
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      };
    }
    case 'percentage': {
      return {
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      };
    }
    default: {
      return {};
    }
  }
};

// https://stackoverflow.com/a/2901298/8249733
export const numberWithCommas = (x: number | string) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
